import React, { useRef, useEffect, useState } from "react";
import {
  IoIosArrowDropdownCircle,
  IoIosArrowDropupCircle,
} from "react-icons/io";
import "./Collapsible.css";

const Collapsible = ({ isOpen, handleCollapse, children, title }) => {
  const ChildrenRef = useRef(null);
  const [Height, setHeight] = useState(null);
  const handleFilterOpening = () => {
    handleCollapse();
  };

  useEffect(() => {
    if (isOpen) setHeight(ChildrenRef.current?.getBoundingClientRect().height);
    else setHeight(0);
  }, [isOpen]);

  return (
    <>
      <div className="collapsibleCard">
        <div>
          <div className="card-interact" onClick={handleFilterOpening}>
            <h6 className="card-title">{title}</h6>
            <div className="expand ">
              {!isOpen ? (
                <IoIosArrowDropdownCircle color="#002677" />
              ) : (
                <IoIosArrowDropupCircle color="#002677" />
              )}
            </div>
          </div>
        </div>

        <div className="my-collapse" style={{ Height }}>
          <div ref={ChildrenRef}>
            {isOpen && <div className="children">{children}</div>}
          </div>
        </div>
      </div>
    </>
  );
};

export default Collapsible;
